/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 09:55:58
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import UserConfigApi, { UserConfigDOI } from './api/userConfigApi';
import { Integer } from 'src/types/base';
import { createNamespace } from 'src/util/bem';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumSex from 'src/enums/enumSex';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import EnumOperates from 'src/enums/enumOperates';
import RegexCheck from 'src/util/regexCheck';
import IconCustom from 'src/components/icon/iconCustom';
import Upload from 'src/types/iview/Upload';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';
import EnumAudit from 'src/enums/enumAudit';

export namespace UserOperateVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        user_id?: Integer;
        real_name: string;
        mobile: string;
        passwords?: string;
        confirmPassword?: string;
        sex: Integer;
        identity_card: string;
        email: string;
        organization: Integer;
        role_id: Integer;
        remark: string;
        status: Integer;
        system_name?:string;
        english_system_name?:string;
        logo_url?:string;
        is_audit: Integer;
    }
}

@Component
class UserOperateModal extends Vue.Component<UserOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    uploading: boolean = false;

    formData: UserOperateVOI.FormDataI = {
        real_name: '',
        mobile: '',
        passwords: '',
        confirmPassword: '',
        sex: null,
        identity_card: '',
        email: '',
        organization: null,
        role_id: null,
        remark: '',
        status: 0,
        system_name:'',
        english_system_name:'',
        logo_url:'',
    };
    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: UserConfigDOI.OperateParamsI = {
            ...this.formData,
            sex: this.formData.sex||-2
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await UserConfigApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.user_id = this.id;
                res = await UserConfigApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    created() {
        let t = this;
        this.rules = {
            mobile: [{ validator: RegexCheck.checkMobilePhone, trigger: 'blur' }],
            identity_card: [{ validator: RegexCheck.checkPersonId, trigger: 'blur' }],
            email: [{ validator: RegexCheck.checkEmail, trigger: 'blur' }],
            confirmPassword: []
        };
        if(this.operate === EnumOperates.Add.getName()) {
            this.rules.confirmPassword= [
                {
                    validator: (rule, value, callback) => {
                        if (t.formData.confirmPassword !== t.formData.passwords) {
                            callback(new Error('两次输入密码不同'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ]
        }
    }
    async mounted() {
        if (this.operate !== EnumOperates.Add.getName()) {
            let { code, data } = await UserConfigApi.searchDetail(this.id);
            if (code === 0) {
                this.formData = {
                    ...data[0],
                };
            }
        }
    }

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            this.formData.logo_url=res.data.url;
        }
    }

    checkFileExtension(fileName) {
        const lowerCaseFileName = fileName.toLowerCase();
        return lowerCaseFileName.endsWith('.png') || lowerCaseFileName.endsWith('.jpg') || lowerCaseFileName.endsWith('.jpeg');
    }

    render(h) {
        return (
            this.formData.role_id === 1?
            <Modal
                class={createNamespace('modal')}
                title={'用户'+this.operate}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={EnumOperates.Detail.getName()===this.operate}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="系统名称" prop="system_name" required style="display: inline-block;width:45%">
                        <Input maxlength={30} v-model={this.formData.system_name} placeholder="请输入系统名称建议10个字符内" />
                    </form-item>
                    <form-item label="系统英文名称" prop="english_system_name" style="display: inline-block;width:45%">
                        <Input v-model={this.formData.english_system_name} placeholder="请输入系统名称" />
                    </form-item>
                    <form-item label="上传logo"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/ops/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            accept="image/*"
                            before-upload={(file) => {
                                if (!this.checkFileExtension(file.name)) {
                                    Toast.error('文件格式不正确');
                                    return false;
                                }
                                this.uploading = true;
                            }}
                        >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                        </Upload>
                        <div class={createNamespace('upload-text')}>支持扩展名： .png .jpg .jpeg 文件大小必须小于等于120*110</div>
                    </form-item>
                </i-form>
                <div slot="footer" v-if={EnumOperates.Detail.getName()!==this.operate}>
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>:
            <Modal
                class={createNamespace('modal')}
                title={'用户'+this.operate}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={EnumOperates.Detail.getName()===this.operate}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="姓名" prop="real_name" required={this.operate !== EnumOperates.Detail.getName()} style="display: inline-block;width:45%">
                        <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.real_name} placeholder="请输入" />
                    </form-item>
                    <form-item label="手机号" prop="mobile" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%">
                        <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.mobile} placeholder="请输入" />
                    </form-item>
                    <div v-if={this.operate === EnumOperates.Add.getName()}>
                        <div style="width: 0px;display: inline-block;overflow: hidden">
                            <input />
                        </div>
                        <form-item label="密码" prop="passwords" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%">
                            <Input v-model={this.formData.passwords} placeholder="请输入" type="password" >
                                <IconCustom type="icon-jianpan" slot="suffix" color="#fff"/>
                            </Input>
                        </form-item>
                        <form-item label="确认密码" prop="confirmPassword" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%">
                            <Input v-model={this.formData.confirmPassword} placeholder="请输入" type="password" >
                                <IconCustom type="icon-jianpan" slot="suffix" color="#fff"/>
                            </Input>
                        </form-item>
                    </div>
                    <form-item label="性别" prop="sex"  style="display: inline-block;width:45%" type='number'>
                        <CommonSelect disabled={this.operate === EnumOperates.Detail.getName()} dataSource={EnumSex.getList()} v-model={this.formData.sex} />
                    </form-item>
                    <form-item label="身份证号" prop="identity_card"  style="display: inline-block;width:45%">
                        <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.identity_card} placeholder="请输入" />
                    </form-item>
                    <form-item label="邮箱" prop="email"   style="display: inline-block;width:45%">
                        <Input disabled={this.operate === EnumOperates.Detail.getName()} v-model={this.formData.email} placeholder="请输入" />
                    </form-item>
                    <form-item label="所属组织" prop="organization" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%" type="number">
                        <EntitySelect disabled={this.operate === EnumOperates.Detail.getName()} type={EnumEntity.Organization.getId()} v-model={this.formData.organization} />
                    </form-item>
                    <form-item label="所属角色" prop="role_id" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%" type="number">
                        <EntitySelect disabled={this.operate === EnumOperates.Detail.getName()} type={EnumEntity.Role.getId()} v-model={this.formData.role_id} />
                    </form-item>
                    <form-item v-if={EnumOperates.Detail.getName()!==this.operate} label="状态" prop="status" required={this.operate !== EnumOperates.Detail.getName()}  style="display: inline-block;width:45%" type="number">
                        <radio-group
                                v-model={this.formData.status}
                            >
                                <radio size="large" label={0}>正常</radio>
                                <radio size="large" label={1}>停用</radio>
                            </radio-group>
                    </form-item>
                    <form-item label="是否审核权限" required prop="is_audit"  style="display: inline-block;width:45%" type='number'>
                        <CommonSelect disabled={this.operate === EnumOperates.Detail.getName()} dataSource={EnumAudit.getList()} v-model={this.formData.is_audit} />
                    </form-item>
                    <form-item label="备注" prop="remark" style="display: inline-block;width:90%">
                        <Input disabled={this.operate === EnumOperates.Detail.getName()} placeholder="请输入" v-model={this.formData.remark} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer" v-if={EnumOperates.Detail.getName()!==this.operate}>
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertUserOperateModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<UserOperateVOI.PropsI>(UserOperateModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
